import * as $ from 'jquery';

declare var jwplayer: any;
declare var videojs: any;
declare var swfobject: any;
declare function __doPostBack(eventTarget: string, eventArguments: any);

import { LessonSetup } from "./lessonsetup";

export class MemberLesson {
    timerDoneFlag: boolean;
    VideoDoneFlag: boolean;
    HasVideo: boolean;
    updateLessonCurrentValue: number;
    isWatchCourseActivity: boolean; // watching course activity?
    idleSeconds: number;
    nextButtonPostBackId: string;
    onTimerExpired;
    readonly beaconSupport: boolean; // browser supports beacons?
    readonly lessonSetup: LessonSetup;

    constructor(lessonSetup: LessonSetup, onTimerExpired = null) {
        this.timerDoneFlag = false;
        this.VideoDoneFlag = false;
        this.HasVideo = false;
        this.updateLessonCurrentValue = 0;
        this.isWatchCourseActivity = false;
        this.lessonSetup = lessonSetup;
        this.onTimerExpired = onTimerExpired;

        if (navigator.sendBeacon) {
            this.beaconSupport = true;
        } else {
            this.beaconSupport = false;
        }

        // this doesn't have to be in jquery ready. So don't put any jquery in here
    }

    // This must be done in jquery ready
    init() {
        const self = this;

        $('#enlargeText').on('click', function () {
            self.updateLessonFontSize(2);
            return false;
        });
        $('#shrinkText').on('click', function () {
            self.updateLessonFontSize(-2);
            return false;
        });

        $('#siteheader_panelNav a, div.top-links a, #navigation a').on('click', function (e) {
            if (!self.checkNavigateAway()) {
                e.preventDefault();
            }
        });
        if (this.lessonSetup.lessonInactivityTimerSeconds > 0) {
            this.addCourseActivityRestrictions();
        }

        // periodic tracking
        if (this.lessonSetup.trackActive) {
            this.doLessonTrack();
        }
    }

    /**
     * Initiates the tracking of a lesson through a SignalR hub connection.
     */
    doLessonTrack() {
        const lessonId = this.lessonSetup.purchaseItemSchoolLessonID;
        const purchaseItemId = this.lessonSetup.purchaseItemID;
        const connection = $.hubConnection('/signalr');
        const lessonHub = connection.createHubProxy('lesson');

        connection
            .start()
            .done(function () {
                setInterval(function () {
                    lessonHub.invoke("trackLesson", lessonId, purchaseItemId)
                }, 10000);
            });
        
        connection.disconnected(function () {
            setTimeout(function() {
                connection.start();
            }, 5000); // Restart connection after 5 seconds.
        })
    }

    // Add a course activity restriction
    addCourseActivityRestrictions() {
        const self = this;
        this.isWatchCourseActivity = true;
        this.idleSeconds = 0;

        // If we have an inactivity timer, then monitor every second
        if (this.lessonSetup.lessonInactivityTimerSeconds > 0) {
            setInterval(() => { self.inactivityTimerIncrement(); }, 1000);
        }
        $(document).on('mousemove keypress mousedown mousewheel scroll', '', function (e) {
            self.idleSeconds = 0;
        });

        window.addEventListener("unload", () => { self.logUnload(); }, false);
    }

    // If we have an unload beacon, then add a log entry
    logUnload() {
        if (this.isWatchCourseActivity && this.beaconSupport) {
            // turned off if timers are elapsed
            let data = new FormData();
            data.append('pislid', this.lessonSetup.purchaseItemSchoolLessonID.toString());
            navigator.sendBeacon("/member/TrafficSchoolLessonUnload.ashx", data);
        }
    }

    timerDone() {
        this.timerDoneFlag = true;

        if (this.lessonSetup.timerSeconds > 0) {
            this.doLessonTrack();

            if (this.onTimerExpired !== null) {
                this.onTimerExpired();
            }
        }
    }

    timerDoneMax() {
        window.location.href = "TrafficSchoolMaxTime.aspx";
    }

    timerDoneBreak() {
        window.location.href = "TrafficSchoolBreak.aspx";
    }

    timerDoneSecurityQuestions() {
        window.location.href = "TrafficSchoolSecurityQuestion.aspx?timer=1&id=" + this.lessonSetup.purchaseItemSchoolLessonID;
    }

    checkNext(): boolean {
        const videosnotdone = this.HasVideo && this.lessonSetup.videoRequireDone && !this.VideoDoneFlag;
        if (videosnotdone) {
            alert("You must watch the entire video before proceeding to the next lesson.");
            return false;
        }

        if (this.timerDoneFlag) {
            // turn off unload beacon
            this.isWatchCourseActivity = false;
            return true;
        }
        else {
            const time = $('#lessontimerwarning').html().toLowerCase();
            alert('You must spend ' + time + ' on this page.');
            return false;
        }
    }

    videoDone() {
        this.VideoDoneFlag = true;
        if (this.lessonSetup.autoAdvanceAfterVideo) {
            this.clickNextButton();
        }
    }

    // returns true if we allow the navigation
    checkNavigateAway(): boolean {
        if (this.timerDoneFlag) {
            return confirm("You must click the Next button to receive credit for time spent on this page.\n\nDo you wish to exit this page anyway? (OK = Yes, Cancel = No)");
        }
        else {
            if (this.isWatchCourseActivity) {
                // special restrictions!
                if (confirm("Do you wish to exit this page? (OK = Yes, Cancel = No)")) {
                    window.location.replace("TrafficSchoolLessonTimeout.aspx?reason=redirect");
                }
                return false;
            }
            else {
                return confirm("Do you wish to exit this page? (OK = Yes, Cancel = No)");
            }
        }
    }

    // Check to see if there's no activity on the page
    inactivityTimerIncrement() {
        this.idleSeconds++;
        $('#timers-popup').find('dd:eq(5)').html(this.idleSeconds.toString());
        if (this.idleSeconds > this.lessonSetup.lessonInactivityTimerSeconds) {
            window.location.replace("TrafficSchoolLessonTimeout.aspx?reason=timeout");
        }
    }

    // jwplayer... obsolete
    showVideo(playerid: string, videofilemp4: string, videothumbnail: string, width: number, height: number) {
        const self = this;
        this.HasVideo = true;

        const setupvideo = {
            flashplayer: '/images/jwplayer/jwplayer.flash.swf',
            aspectratio: self.getaspectratio(width, height),
            width: "100%",
            image: videothumbnail,
            file: videofilemp4,
            events: {
                onComplete: function () {
                    self.videoDone();
                }
            }
        };

        jwplayer(playerid).setup(setupvideo);
    }

    clickNextButton() {
        __doPostBack(this.nextButtonPostBackId, '');
    }

    // videojs our current player
    showVideoJS(playerid: string) {
        const self = this;
        this.HasVideo = true;

        const video = videojs(playerid).ready(function () {
            const player = this;

            player.on('ended', function () {
                self.videoDone();
            });

            if (self.lessonSetup.videoRequireDone) {
                // disable any clicks in the video control bar if we want them to watch the 
                // whole thing.
                let currentTime = 0;

                player.on("seeking", function (event) {
                    if (currentTime < player.currentTime()) {
                        player.currentTime(currentTime);
                    }
                });

                player.on("seeked", function (event) {
                    if (currentTime < player.currentTime()) {
                        player.currentTime(currentTime);
                    }
                });

                setInterval(function () {
                    if (!player.paused()) {
                        currentTime = player.currentTime();
                    }
                }, 1000);
            }
        });
    }

    gcd_rec(a: number, b: number): number {
        if (b) {
            return this.gcd_rec(b, a % b);
        } else {
            return Math.abs(a);
        }
    }

    getaspectratio(width: number, height: number): string {
        const gcd = this.gcd_rec(width, height);
        return (width / gcd).toString() + ":" + (height / gcd).toString();
    }

    showReadalong(playerid, audiosource) {
        const isMobile = jwplayer.utils.isMobile();
        if (isMobile) {
            const mobileplayer = $('<audio style="width:100%" id="ra_player" name="ra_player" src="' + audiosource + '" controls="controls"></audio>');
            $('#' + playerid).append(mobileplayer); // put it into the DOM
        }
        else {
            jwplayer(playerid).setup(
                {
                    'id': playerid,
                    'wmode': 'transparent',
                    'icons': 'true',
                    'allowscriptaccess': 'always',
                    'allownetworking': 'all',
                    'file': audiosource,
                    'width': '100%',
                    'height': '30',
                    'controlbar': 'bottom',
                    'dock': 'false',
                    'modes': [

                        { type: 'flash', src: '/images/jwplayer/jwplayer.flash.swf' },
                        {
                            type: 'html5',
                            config: {
                                'file': audiosource,
                                'provider': 'sound'
                            }
                        }
                    ]
                });
        }
    }

    updateLessonFontSize(px: number) {
        if (this.updateLessonCurrentValue + px > 12 || this.updateLessonCurrentValue + px < -4) {
            return;
        }
        this.updateLessonCurrentValue += px;

        $('.LessonContent').find('div,span,p,li,h1,h2,h3,h4,h5,h6,strong,em').each(function () {
            const $this = $(this);
            const fontSize = parseFloat($this.css('font-size')) + px;
            const lineHeight = parseFloat($this.css('line-height')) + px;
            $this.css('font-size', fontSize + 'px');
            $this.css('line-height', lineHeight + 'px');
        });
    }

    setupFlashEdge() {
        if (typeof swfobject !== 'undefined' &&
            swfobject.getFlashPlayerVersion().major !== 0) {
            const $flashdivs = $(".flash-container");
            $flashdivs.each(function () {
                const medianame = $(this).data("medianame");
                // find matching edge 
                const $matchedge = $('.edge-container[data-medianame="' + medianame + '"]');
                $matchedge.hide(); // maybe remove from DOM?
            });
        }
        else {
            const $edgedivs = $(".edge-container");
            $edgedivs.each(function () {
                const medianame = $(this).data("medianame");
                // find matching flash 
                const $matchflash = $('.flash-container[data-medianame="' + medianame + '"]');
                $matchflash.hide(); // maybe remove from DOM?
            });
        }
    }
}


